import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
`;

export const CheckIcon = styled.img`
  width: 20px;
  height: 20px;
`;
